
let _ = require('../_.js');
let $ = jQuery;


/***
    * API call to PHP backend ajax functions.  The return format of an api call should follow:
    * ['success' => (true/false), 'return' => mixed data].  Returns a promise.  If the response=success
    * the promise resolves, otherwise its rejected.  The return data is sent as the argument to the resolution.
    * The reject function may contain a string of a browser error if the browser connection failed.
    * 
    * This is depricated in favor of ajax requests to the ace backend directly.
    *
    * @param {Auct} fn   - file in ajax/fn.php
    * @param {*} action  - 'action' paramater added to get values.
    * @param {*} data    - Mixed data to send to the API as POST values.
    * @param {*} form_id - If passed, will set a ajax loading indicator on the form's submit button
    * @returns Promise
    */
_.backend_ajax = function (fn, action, data = {}, form_id = null) {
    let url = "/ajax/api.php?action=" + encodeURIComponent(fn + "/" + action);

    let headers = {};

    // Set the session
    let token = _.AuctionUI_Session.get_token_cookie();
    if (token && token !== '') {
        headers['Authorization'] = 'Bearer ' + token;
    }

    // Add ajax indicator
    if (form_id != null) {
        let $form = $(document.getElementById(form_id));
        if ($form.length && $form.find('button[type="submit"]').length) {
            // Get the submit button
            let $submit = $form.find('button[type="submit"]');

            // Disable the submit button and replace its content with the loading animation
            $submit.prop('disabled', true);
            $submit.addClass('ac-async-pleasewait');
            $submit.blur();
        }
    }

    return new Promise(function (resolve, reject) {
        _.mutex('_core_realtime', async function () {
            await new Promise(function (resolve2) {
                $.ajax({
                    type: "POST",
                    url: _.plugin_base_url() + url,
                    data: data,
                    headers: headers,
                    dataType: "html",
                    // Always release the _core_realtime lock, whatever happened to the request:
                    // a held lock blocks every later backend call (bidding included) in this tab.
                    complete: function () {
                        resolve2();
                    },
                    success: function (response) {
                        try {
                            response = JSON.parse(response);
                        } catch (e) {
                            console.error("Invalid JSON from", url, response);
                            reject(e);
                            return;
                        }

                        // Remove ajax indicator
                        if (form_id != null) {
                            let $form = $(document.getElementById(form_id));
                            if ($form.length && $form.find('button[type="submit"]').length) {
                                // Get the submit button
                                let $submit = $form.find('button[type="submit"]');
                                $submit.prop('disabled', false);
                                $submit.removeClass('ac-async-pleasewait');
                            }
                        }

                        if (response.debug) {
                            console.log("API: " + url, data, " Debug: ", response.debug);
                        } else if (action != 'status') {
                            if (url.indexOf('web_session') == -1 && url.indexOf('get_multiple') == -1) { // Supress web_session::ping and model::get_multiple
                                console.log("API: " + url, data);
                            }
                        }

                        // Treat all records in response._modified as real time updated orm data
                        if (response._modified) {
                            for (let rd of response._modified) {
                                _.__update_data_record_from_ajax_response(rd[0], rd[1], rd[3], 'hybrid');
                            }
                        }

                        if (response.success === true || response.success === "true") {
                            resolve(response.return);
                            resolve2();
                        } else if (response.success === false || response.success === "false") {
                            console.warn(response.return);
                            reject(response.return);
                            resolve2();

                        } else {
                            console.error("Error on ajax request", url, data);
                            console.error("Response was", response);
                            console.error("Incorrect error return syntax, should contain response.return");
                            reject(new Error(response));
                            resolve2();
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        // Network failure or aborted (e.g. navigating away): no response to report
                        if (jqXHR.readyState < 4) {
                            reject(new Error("Request failed before a response: " + textStatus));
                            return;
                        }
                        // Remove ajax indicator

                        if (form_id != null) {
                            let $form = $(document.getElementById(form_id));
                            if ($form.length && $form.find('button[type="submit"]').length) {
                                // Get the submit button
                                let $submit = $form.find('button[type="submit"]');
                                $submit.prop('disabled', false);
                                $submit.removeClass('ac-async-pleasewait');
                            }
                        }

                        console.error("Error on ajax request", url, data);
                        console.error("Response was", jqXHR.responseText);

                        reject(new Error(textStatus));
                        resolve2();
                    }
                });
            });
        });
    });
}